import React, { Component } from 'react'

const Tags = (props) => {
    const { style, tags, valueState, action } = props
    const boxTags = tags ? tags : []
    return(
        <select style={{ ...style}} name='tag' className="form-control form-control" 
            onChange={(value) => action ? action(value) : null } 
            value={valueState}>
            <option value={''} key={'optionTodos'}>Todos</option>
            {boxTags.map( (tag,index) => (
                <option value={tag.titulo} key={'option'+index}>{tag.titulo}</option>
            ))}
        </select>
    )
}

export default Tags